import type { UpdateStatus } from "@/shared/types/update";

// Обертка для Electron IPC API
declare global {
  interface Window {
    electronAPI: {
      getAppPath: () => Promise<string>;
      getCachePath: () => Promise<string>;
      getTempPath: () => Promise<string>;
      isFlashAvailable: () => Promise<boolean>;
      readFile: (filePath: string) => Promise<Uint8Array>;
      writeFile: (filePath: string, data: Uint8Array) => Promise<boolean>;
      fileExists: (filePath: string) => Promise<boolean>;
      deleteFile: (filePath: string) => Promise<boolean>;
      readDir: (dirPath: string) => Promise<string[]>;
      registerSwfFile: (filePath: string) => Promise<string>;
      unregisterSwfFile: (fileId: string) => Promise<void>;
      checkForUpdates: () => Promise<{
        updateAvailable: boolean;
        version?: string;
        releaseNotes?: string;
      }>;
      startUpdate: () => Promise<void>;
      getUpdateStatus: () => Promise<UpdateStatus>;
      onUpdateStatusChange: (
        callback: (status: UpdateStatus) => void
      ) => () => void;
    };
  }
}

export const electronAPI = window.electronAPI;
